module.exports = __webpack_public_path__ + "static/media/soundbox-logo.fa4485f4.png";